import React, {useState, useEffect, useContext} from "react";
import {Link} from 'react-router-dom'
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MuiAlert from '@material-ui/lab/Alert';
// core components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
// Ficha components
import BlankSpace from 'Ficha/components/BlankSpace'
import MobileBlankSpace from 'Ficha/components/MobileBlankSpace'
import SubTitle from 'Ficha/components/SubTitle'
import { TextInput } from 'Ficha/components/TextInput'
import { DateInput } from 'Ficha/components/DateInput'
import { RadioInput } from 'Ficha/components/RadioInput'
import { YesNoRadio } from 'Ficha/components/YesNoRadio'
import { NumberInput } from 'Ficha/components/NumberInput'
import { CheckBoxInput } from 'Ficha/components/CheckBoxInput'
import CheckBoxGroup from 'Ficha/components/CheckBoxGroup'
import listaDoencas from 'Ficha/components/listaDoencas'
// User & DB
import { UserContext } from 'context/userContext'
import { criarFicha, atualizarFicha } from 'firebase/firestoreData'
// calculations
import { calcularIMC, calcularIdeal, calcularPredito, calcularAjustado, formatarData, calcularIdade } from 'Ficha/calculations/formulas'
// react-hook-form
import {useForm, Controller} from 'react-hook-form'

import styles from 'Ficha/styles/newStyles'

const useStyles = makeStyles(styles);

export default function New(props) {
  const classes = useStyles()
  const history = useHistory();
  const passedValues = props.location.state
  const [editMode, setEditMode] = useState(false)
  const [defaultValues, setdefaultValues] = useState(passedValues ? passedValues : { tabagismo: false, mallampati: null, teste: false, vad: false })
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const {currentUser, userOptions, groupName, isPro, recordsCount} = useContext(UserContext)
  const prescricoes = userOptions ? [userOptions.prescricaoPadrao1,
                                     userOptions.prescricaoPadrao2,
                                     userOptions.prescricaoPadrao3,
                                     userOptions.prescricaoPadrao4,
                                     userOptions.prescricaoPadrao5]
                                  : []
  // react-hook-form and watch() constants
  const { register, handleSubmit, control, errors, reset, watch, setValue } = useForm({defaultValues: defaultValues})
  const peso = watch('peso')
  const altura = watch('altura')
  const sexo = watch('sexo')
  const procedimentoPrevio = watch('procedimentoPrevio')
  const eventoAdverso = watch('eventoAdverso')
  const alergia = watch('alergia')
  const comorbidade = watch('comorbidade')
  const medicamento = watch('medicamento')
  const criticos = watch('criticos')
  const exameFisicoAlterado = watch('exameFisicoAlterado')
  const dataNascimento = watch('dataNascimento')



  useEffect(() => {
    setValue('dataNascimento', formatarData(dataNascimento))
    if (dataNascimento !== undefined && dataNascimento.length === 10) {
      setValue('idade', calcularIdade(dataNascimento))
    } 
  },[dataNascimento, setValue])

  useEffect(() => {
    setValue('imc', calcularIMC(peso, altura))
    setValue('pesoIdeal', calcularIdeal(sexo, altura))
    setValue('pesoPredito', calcularPredito(sexo, altura))
    setValue('pesoAjustado', calcularAjustado(sexo, peso, altura))
  },[sexo, peso, altura, setValue])

  useEffect(() => {
    passedValues && setEditMode(true)
  },[passedValues])

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  function dataSavedSuccessfully() {
    setShowSuccessMessage(true)
    setTimeout(function(){history.push("/records")}, 500);
  }

  const onSubmit = (dataToSave, e) => {
    if (editMode) {
       atualizarFicha(defaultValues.id, {data: Date(dataToSave.data),...dataToSave}, dataSavedSuccessfully)
       setdefaultValues({id: defaultValues.id, ...dataToSave})
    } else {
       criarFicha(currentUser.uid, dataToSave, groupName, dataSavedSuccessfully)
    }
    reset(dataToSave)
  };

  /*      Componentes customizados para evitar repetição de código
    fieldsize (1 a 12):  a proporção da coluna no tamanho md,
    a soma dos elementos para completar uma linha deve ser igual a 12
    TextInput: maxLength máximo de caracteres aceitos; default 200
    NumberInput: min - valor mínimo; default 0
                 max - valor máximo; default 9999999
                 step - intervalo aceito entre os números; default 1    */
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
    { (!isPro && recordsCount === 20) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="error">
                    Você excedeu sua cota gratuita. Assine o PRO agora para realizar atendimentos ilimitados.
                  </MuiAlert>
    )}
    { (!isPro && recordsCount > 20) ?
        ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="error">
                  Você excedeu sua cota gratuita. Assine o PRO agora para realizar atendimentos ilimitados.
          </MuiAlert>)
                  : <>

    <Card>
      <CardHeader color="primary">
<h4 className={classes.cardTitle}>Identificação</h4>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <TextInput label="Nome" name="nome" maxLength={70} required autoComplete="off" inputProps={{style: {textTransform: 'uppercase'}}} fieldsize={5} ref={register}/>
          <TextInput label="Data de Nascimento" placeholder="dd/mm/aaaa" name="dataNascimento" InputLabelProps={{ shrink: true }} fieldsize={2} ref={register}/>
          <TextInput className={classes.idadeInput} variant="outlined" label="" name="idade"  fieldsize={2}ref={register}/>
          <Controller label="Data da Consulta" name="data" as={DateInput} control={control} defaultValue={new Date()} required fieldsize={3}/>
          < MobileBlankSpace/>
          <TextInput label="Profissão" name="profissao" maxLength={50} fieldsize={4} ref={register}/>
          <TextInput label="CPF" name="cpf"  maxLength={14} autoComplete="off" fieldsize={4} ref={register}/>
          < MobileBlankSpace/>
          <Controller name="sexo" control={control} defaultValue=""  as={
            <RadioInput label="Sexo" options={["Masc", "Fem"]} small={"true"} horizontal="true" fieldsize={4}/>}
           />
          <TextInput label="Hospital" name="hospital" maxLength={40} fieldsize={4} ref={register}/>
          <TextInput label="Cirurgião" name="cirurgiao" maxLength={50} fieldsize={4} ref={register}/>
          <TextInput label="Convênio" name="convenio" maxLength={40} fieldsize={2} ref={register}/>
          < MobileBlankSpace/>
          <Controller name="acomodacao" control={control} defaultValue=""  as={
            <RadioInput label="Acomodação" options={["Apto", "Enfa"]} small={"true"} fieldsize={2}/>}
           />
          <TextInput label="Procedimento(s)" name="procedimentos" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
        </GridContainer>
      </CardBody>
      <br/>
      <CardHeader color="primary">
<h4 className={classes.cardTitle}>Avaliação Clínica</h4>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <Controller name="procedimentoPrevio" control={control} defaultValue={'false'} as={<YesNoRadio text="• Já foi submetido a procedimento com anestesia?" />}/>
          { procedimentoPrevio === 'true' &&
            <>
            <TextInput label="Procedimentos Prévios" name="procedimentosPrevios" ref={register}/>
            <TextInput label="Anestesias Prévias" name="anestesiasPrevias" ref={register}/>
            <Controller name="eventoAdverso" control={control} defaultValue={'false'} as={<YesNoRadio text="• Apresentou evento adverso causado pela anestesia?" />}/>
            </>
          }
          { eventoAdverso === 'true' &&
            <TextInput label="Eventos Adversos" name="eventosAdversos" ref={register}/>
          }
          <Controller name="alergia" control={control} defaultValue="" rules={{ required: true }} as={<YesNoRadio text="• Possui alergia conhecida?" />}/>
          { alergia === 'true' &&
            <TextInput label="Alergias" name="alergias" required ref={register}/>
          }
          {errors.alergia && <p className={classes.errors}>*** ATENÇÃO:  O CAMPO "ALERGIA" É OBRIGATÓRIO! </p>}
          <Controller name="comorbidade" control={control} defaultValue={'false'} as={<YesNoRadio text="• Possui comorbidade ou condição clínica relevante?" />}/>
          { comorbidade === 'true' &&
            <>
              {listaDoencas.map((sistema, index) => (
                <CheckBoxGroup key={index} title={Object.keys(sistema)[0]}>
                  {listaDoencas[index][Object.keys(sistema)[0]].map(doenca => (
                    <Controller key={doenca[0]} name={doenca[0]} control={control} defaultValue={false} render={(props) => (
                      <CheckBoxInput label={doenca[1]} onChange={(e) => props.onChange(e.target.checked)} checked={props.value}/>)}
                    />
                  ))
                  }
                </CheckBoxGroup>
              ))}
              <TextInput label="Outras Comorbidades:" name="outrasComorbidades" ref={register}/>
            </>
          }
          <Controller name="medicamento" control={control} defaultValue={'false'} as={<YesNoRadio text="• Faz uso de algum medicamento?" />}/>
          { medicamento === 'true' &&
            <TextInput label="Medicamentos" name="medicamentos" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
          }
          <Controller name="criticos" control={control} defaultValue={'false'} as={<YesNoRadio text="• Possui pontos críticos?" />}/>
          { criticos === 'true' &&
            <>
            <Controller name="broncoaspiracao" control={control} as={<YesNoRadio text="Risco de Broncoaspiração?" />}/>
            <Controller name="sangramento" control={control} as={<YesNoRadio text="Risco de Sangramento?" />}/>
            <Controller name="trombose" control={control} as={<YesNoRadio text="Risco de Trombose Venosa?" />}/>
            </>
          }
          <Controller name="exameFisicoAlterado" control={control} defaultValue={'false'} as={<YesNoRadio text="• Apresenta alteração no exame físico?" />}/>
          { exameFisicoAlterado === 'true' &&
            <TextInput label="Exame Físico" name="exameFisico" defaultValue={`GERAL: B.E.G., L.O.T.E., mucosas coradas, eupnéico, anictérico\n
ACV: BRNF em 2 tempos, sem sopros\n
AR: MV presentes em AHT, sem ruídos adventícios\n
Extremidades: bem perfundidas, sem edemas`} multiline maxLength={500} ref={register}/>
          }
    < SubTitle text="- DADOS ANTROPOMÉTRICOS:"/>
          <NumberInput label="Peso" name="peso" max={300} step="0.1" endadornment="kg" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="Altura" name="altura" max={250} endadornment="cm" fieldsize={2} mobilesize={6} ref={register}/>
          < MobileBlankSpace/>
          <NumberInput label="IMC" name="imc" min={1} max={250} step="0.1" endadornment="kg/cm²" fieldsize={2} mobilesize={6} InputLabelProps={{ shrink: true }} ref={register}/>
          <NumberInput label="Peso Ideal" name="pesoIdeal" min={1} max={250} step="0.1" endadornment="kg" fieldsize={2} mobilesize={6} InputLabelProps={{ shrink: true }} ref={register}/>
          < MobileBlankSpace/>
          <NumberInput label="Peso Ajustado" name="pesoAjustado" min={1} max={250} step="0.1" endadornment="kg" fieldsize={2} mobilesize={6} InputLabelProps={{ shrink: true }} ref={register}/>
          <NumberInput label="Peso Predito p/ VM" name="pesoPredito" min={1} max={250} step="0.1" endadornment="kg" fieldsize={2} mobilesize={6} InputLabelProps={{ shrink: true }} ref={register}/>
    < SubTitle text="- SINAIS VITAIS:"/>
          <TextInput label="PA" name="pa" maxLength={9} endadornment="mmHg" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="FC" name="fc" max={350} endadornment="bpm" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="FR" name="fr" max={200} endadornment="irpm" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="Temp" name="temp" max={45} step="0.1" endadornment="°C" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="SpO2" name="spo2" max={100} endadornment="%" fieldsize={2} mobilesize={6} ref={register}/>
          <NumberInput label="Dor (0 a 10)" name="dor" max={10} fieldsize={2} mobilesize={6} ref={register}/>
    < SubTitle text="- VIAS AÉREAS:"/>
          <Controller name="mallampati" control={control} defaultValue=""  as={
            <RadioInput label="Mallampati" options={["I", "II", "III", "IV"]} fieldsize={2}/>}
            />
          <Controller name="aberturaOral" control={control} defaultValue=""  as={
            <RadioInput label="Abertura Oral" vertical="true" options={["> 4cm", "< 4cm"]} fieldsize={2}/>}
            />
          <Controller name="mobilidadeCervical" control={control} defaultValue=""  as={
            <RadioInput label="Mobilidade Cervical" vertical="true" options={["Normal", "Limitada"]} fieldsize={2}/>}
            />
          <Controller name="dtm" control={control} defaultValue=""  as={
            <RadioInput label="Distância Tireo-Mento" vertical="true" options={["> 6cm", "< 6cm"]} fieldsize={2}/>}
            />
          <Controller name="dem" control={control} defaultValue=""  as={
            <RadioInput label="Dist Esterno-Mento" vertical="true" options={["> 12,5cm", "< 12,5cm"]} fieldsize={2}/>}
          />
          <Controller name="proteseDentaria" control={control} defaultValue=""  as={
            <RadioInput label="Prótese Dentária" vertical="true" options={["Não", "Sim"]} fieldsize={2}/>}
          />
          < BlankSpace fieldsize={2}/>
          < BlankSpace fieldsize={10}>
            <div className={classes.vad}>
              <Controller name="vad" control={control} as={<YesNoRadio text="Risco de Via Aérea Difícil?" />}/>
            </div>
            </BlankSpace>
          < BlankSpace height={40}/>
        </GridContainer>
      </CardBody>
      <br/>
      <CardHeader color="primary">
<h4 className={classes.cardTitle}>Exames Complementares</h4>
      </CardHeader>
      <CardBody>
      <GridContainer>
        <TextInput label="Hb" name="hb" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Ht" name="ht" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Hm" name="hm" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Leuco" name="leuco" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Plt" name="plt" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Fibrinogênio" name="fibrinogenio" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="TC" name="tc" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="TS" name="ts" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="TP" name="tp" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="INR" name="inr" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="TTPa" name="ttpa" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Ativ Prot" name="ap" endadornment="%" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Uréia" name="ureia" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Creat" name="creat" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Na" name="na" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="K" name="k" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Ca" name="ca" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Mg" name="mg" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Glicemia" name="glicemia" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Hb A1c" name="hba1c" endadornment="%" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="AST" name="ast" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="ALT" name="alt" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Bilirrubinas" name="bil" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="Proteínas" name="prot" fieldsize={2} mobilesize={4} ref={register}/>
        <TextInput label="ECG:" name="ecg" ref={register}/>
        <TextInput label="Radiografia:" name="radiografia" ref={register}/>
        <TextInput label="ECO:" name="eco" ref={register}/>
        <TextInput label="Teste Ergométrico:" name="te" ref={register}/>
        <TextInput label="Outros Exames:" name="outrosExames" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
      </GridContainer>
      </CardBody>
      <br/>
      <CardHeader color="primary">
<h4 className={classes.cardTitle}>Conclusões</h4>
      </CardHeader>
      <CardBody>
      <GridContainer>
        <Controller name="apto" control={control} defaultValue={false} render={(props) => (
            <CheckBoxInput label="Apto para Procedimento Proposto" fieldsize={4} onChange={(e) => props.onChange(e.target.checked)} checked={props.value}/>)}
        />
        <Controller name="uti" control={control} defaultValue={false} render={(props) => (
            <CheckBoxInput label="Solicitar Reserva de UTI" fieldsize={4} onChange={(e) => props.onChange(e.target.checked)} checked={props.value}/>)}
        />
        <Controller name="hemocomponentes" control={control} defaultValue={false} render={(props) => (
            <CheckBoxInput label="Reserva de Hemocomponentes" fieldsize={2} onChange={(e) => props.onChange(e.target.checked)} checked={props.value}/>)}
        />
        <TextInput label="especificar" name="hemoTexto" InputLabelProps={{ shrink: true }} fieldsize={2} ref={register}/>
        <TextInput label="Avaliação de Outras Especialidades" name="avalEspecialidades" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
        <TextInput label="Anotações" name="anotacoes" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
        <TextInput label="Anestesia Proposta" name="anestesiaProposta" fieldsize={6} ref={register}/>
        <TextInput label="Jejum Pré-Operatório" name="jejum" fieldsize={6} ref={register}/>
        < MobileBlankSpace/>
        <TextInput label="Prescrição Pré-Anestésica" name="prescricao" fieldsize={8} placeholder="Pressione Enter para adicionar linhas" InputLabelProps={{ shrink: true }} maxLength={500} multiline ref={register}/>
        <FormControl className={classes.formControl}>
          <InputLabel>Escolher Prescrição</InputLabel>
          <Controller name="prescricoes" defaultValue="" control={control} fieldsize={3}
                      render={({ onChange, onBlur, value, name, ref }) => (
            <Select defaultValue="" onChange={(e) => {setValue('prescricao', e.target.value);}}>
              {prescricoes.filter(prescricao => prescricao !== "")
                .map((prescricao, index) => (
                   <MenuItem key={index+prescricao} value={prescricao}>Prescrição {index+1}</MenuItem>
             ))}
            </Select>
            )}
          />
       </FormControl>
       <Tooltip enterTouchDelay={1} title={`Para definir suas prescrições padrões: salve a Ficha atual e vá
         em "Opções" no menu lateral`}>
         <IconButton aria-label="delete">
           <HelpOutlineIcon />
         </IconButton>
      </Tooltip>
        <TextInput label="ORIENTAÇÕES:" name="orientacoes" placeholder="Pressione Enter para adicionar linhas" multiline ref={register}/>
        <TextInput label="CAMPO OCULTO:" name="oculto" placeholder="Esse campo NÃO será impresso na ficha" multiline ref={register}/>
        < BlankSpace fieldsize={5}/> <NumberInput label="Asa" name="asa" min={1} max={6} autoComplete="off" fieldsize={2} ref={register}/> < BlankSpace fieldsize={5}/>
      </GridContainer>
      </CardBody>
    </Card>
      <Button color="primary" type="submit">SALVAR</Button>
      <Link to="/records"><Button color="primary" type="button">CANCELAR</Button></Link>
    </>
  }
      <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"A ficha foi salva com sucesso"}/>
      { (!isPro && recordsCount > 14 && recordsCount < 20) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                      Resta(m) apenas {20 - recordsCount} ficha(s) na sua cota gratuita. Assine o PRO agora para usar a ferramenta de modo ilimitado.
                    </MuiAlert>
      )}

    </form>
  );
}
